import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import { StateService } from '@uirouter/angular';
import { ScmService } from '../services/scm.service';
import {decodeParams, normalizeCommitish} from '../services/scm.utils';
import * as _ from 'lodash';

@Component({
  selector: 'scm-branch-tag',
  template: require('./scm.branch-tag.component.html')
})
export class BranchTagComponent implements OnInit, OnChanges {
  @Input() scm: any;
  @Input() filterString: string;

  filteredBranches: any = false;
  filteredTags: any = false;
  filterPromise: any = false;
  showBranchSelector: boolean = false;
  commitish: string = '';
  commitishLabel: string;
  revision: string = '';
  setFilter: () => void;

  constructor(
    private stateService: StateService,
    private scmService: ScmService
  ) {
    this.setFilter = _.debounce(this.doFilter.bind(this), 300);
  }

  ngOnInit(): void {
    this.doFilter();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.scm && changes.scm.currentValue) {
      this.setScm(changes.scm.currentValue);
    }
    if (changes.filterString) {
      this.filterString = changes.filterString.currentValue;
      this.setFilter();
    }
  }

  private setScm(scm: any): void {
    this.scm = scm;
    const stateParams = this.stateService.params;
    const isSvn = this.scm.scmType === 'svn';
    const hasParams = !!(stateParams.branch || stateParams.tag || stateParams.commit);

    if (isSvn && !hasParams) {
      this.commitish = 'HEAD';
    } else {
      this.commitish = normalizeCommitish(
        stateParams.branch ||
        stateParams.tag ||
        stateParams.commit ||
        this.scm?.defaultBranchName
      );
    }
    this.commitishLabel = this.getLabel(stateParams);
    this.revision = stateParams.commit || '';

    this.showBranchSelector = !(this.scm.scmType === 'cvs' && !stateParams.path);
  }

  switchTo(type: string, name: string): void {
    // Create params object and nullify commitish params
    var params = {
      ... decodeParams(this.stateService.params),
      branch: null,
      tag: null,
      commit: null,
      browse_path: null,
      browse_file: null
    };
      // Set the new parameter
    params[type] = normalizeCommitish(name);

    // Remove all null/undefined values
    const cleanParams = Object.entries(params)
      .filter(([_, value]) => value !== null && value !== undefined)
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

    // Force reload the state with clean params
    this.stateService.go('.', cleanParams, {
      reload: true,
      inherit: false,
      notify: true
    });
  }

  private doFilter(): void {
    const ignoreBranch = this.scm?.scmType === 'svn' ? 'trunk' : '';

    this.scmService.branches(this.stateService.params.unixName, { filter: this.filterString ?? null, page_size: 15 })
      .then((branches) => {
        this.filteredBranches = _.filter(
          _.get(branches, 'items', []),
          (b) => b.name !== ignoreBranch
        );
        this.filteredBranches = decodeParams(this.filteredBranches);
        /**
          _.forEach(this.filteredBranches, (value, key) => {
              if (typeof value === 'string') {
                  this.filteredBranches[key] = decodeURIComponent(value);
              } else {
                  this.filteredBranches[key] = value;
              }
          });      */
      })
      .catch((result) => console.log(result));

    this.scmService.tags(this.stateService.params.unixName, { filter: this.filterString ?? null, page_size: 15 })
      .then((tags) => {
        this.filteredTags = _.filter(
          _.get(tags, 'items', []),
          (t) => t.name !== ignoreBranch
        );
        this.filteredTags = decodeParams(this.filteredTags);
      })
      .catch((result) => console.log(result));
  }

  private getLabel(stateParams: any): string {
    const isSvn = this.scm?.scmType === 'svn';
    if (!stateParams['branch']) {
      if (stateParams['commit']) {
        return isSvn ? 'Revision' : 'Commit';
      }
      if (stateParams['tag']) {
        return 'Tag';
      }
      if (isSvn) {
        return 'Revision';
      }
    }
    return 'Branch';
  }

  applyRevision(): void {
    if (this.revision) {
      this.switchTo('commit', this.revision);
    }
  }
}
